// components/SimpleSelectField.js
import React from "react";
import { useTranslation } from "react-i18next";

const SimpleSelectField = ({
  field,
  value,
  label,
  options = [],
  errors = {},
  isAdviceLoading = false,
  handleSelecChange,
}) => {
  const { t } = useTranslation();
  const optionsArray = Array.isArray(options) ? options : [];

  return (
    <div className="w-full">
      <span className="text-[#414651] text-[14px] sm:text-[16px] block mb-1">
        {label}
      </span>
      <select
        className={`border p-2 rounded-md w-full h-10 text-sm outline-none bg-white ${
          errors[field] ? "border-red-500" : ""
        } ${isAdviceLoading ? "opacity-70" : ""}`}
        value={value || ""}
        onChange={(e) => handleSelecChange(field, e.target.value)}
        disabled={isAdviceLoading}
      >
        <option value="" disabled>
          {t("preferences.validation.onlyOne")}
        </option>
        {optionsArray.map((option) => (
          <option key={option} value={option}>
            {field === "durationType"
              ? t(`firstFormSteps.durationType.options.${option}`)
              : option}
          </option>
        ))}
      </select>
      {errors[field] && (
        <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">
          {errors[field]}
        </div>
      )}
    </div>
  );
};

export default SimpleSelectField;